import { useEffect } from "react";

import { create } from "zustand";
import { Talent, TalentProfile } from "../types/user";

interface CurrentTalentState {
  currentProfile: null | Talent;
  setCurrentProfile: (profile: TalentProfile | null) => void;
}

const useCurrentTalentStore = create<CurrentTalentState>()((set) => ({
  currentProfile: null,
  setCurrentProfile: (profile) => set(() => ({ currentProfile: profile })),
}));

export const useCurrentTalentProfile = () => {
  const { currentProfile, setCurrentProfile } = useCurrentTalentStore();

  function SetTalentProfile(talent: Talent | null) {
    localStorage.setItem("ACTIVE_TALENT", JSON.stringify(talent));
    setCurrentProfile(talent);
  }
  
  useEffect(() => {
    if (!currentProfile) {
      const user = localStorage.getItem("ACTIVE_TALENT");
      if (user) {
        const userInfo = JSON.parse(user);
        setCurrentProfile(userInfo);
      }
    }
  }, [currentProfile, setCurrentProfile]);
  return { currentProfile, SetTalentProfile };
};

interface AddTalentState {
  addTalent: boolean;
  setAddTalent: (profile: TalentProfile) => void;
}

export const useAddTalent = create<AddTalentState>()((set) => ({
  addTalent: false,
  setAddTalent: (val) => set(() => ({ addTalent: val })),
}));
